__webpack_require__.p = "/tokenised-scrolls/referrals-hub/";